<template>
  <div>
    <b-modal
      ref="paymentPlanModal"
      size="xl"
      header-class="header-gray"
      footer-class="footer-class"
      body-class="body-class"
      hide-footer
      lazy
      :no-enforce-focus="true"
    >
      <template #modal-title>Payment Plan for {{ name }}</template>

      <payment-plan
        :paymentPlanId="paymentPlanId"
        v-if="paymentPlanId"
        :setName="setName"
      ></payment-plan>
    </b-modal>

    <b-modal
      ref="apptModal"
      size="xl"
      header-class="header-gray"
      footer-class="footer-class"
      body-class="body-class"
      hide-footer
      lazy="true"
      :no-enforce-focus="true"
    >
      <template #modal-title>Appointment for {{ name }}</template>

      <Appt
        :apptId="apptId"
        v-if="apptId"
        :setName="setName"
        @hide="
          () => {
            $refs.apptModal.hide();
          }
        "
      ></Appt>
    </b-modal>

    <b-modal
      ref="transactionModal"
      size="md"
      body-class="p-0"
      hide-footer
      lazy
      :no-enforce-focus="true"
    >
      <transaction :id="transactionId" v-if="transactionId"></transaction>
    </b-modal>

    <b-modal
      ref="notificationModal"
      size="xl"
      header-class="header-gray"
      footer-class="footer-class"
      body-class="body-class"
      lazy
      hide-footer
      :no-enforce-focus="true"
    >
      <template #modal-title> Payment Request for {{ name }} </template>

      <notification-control
        :no-enforce-focus="true"
        :notificationId="notificationId"
        :setName="setName"
        v-if="notificationId"
        @close="$refs.notificationModal.hide()"
      ></notification-control>
    </b-modal>

    <b-modal
      ref="customerMembershipBillingModal"
      size="xl"
      header-class="header-gray"
      footer-class="footer-class"
      body-class="body-class"
      hide-footer
      lazy
      :no-enforce-focus="true"
    >
      <template #modal-title>Membership for {{ name }}</template>

      <customer-membership-billing
        :id="customerMembershipBillingId"
        v-if="customerMembershipBillingId"
        :setName="setName"
      ></customer-membership-billing>
    </b-modal>

    <loading-overlay
      :can-cancel="true"
      :active="loading"
      :is-full-page="true"
      :opacity="0"
      :zIndex="9999999999"
      :blur="null"
    >
      <template #default>
        <div>
          <loading-svg></loading-svg>
        </div>
      </template>
    </loading-overlay>

    <notifications></notifications>

    <router-view></router-view>
  </div>
</template>

<script>
import Loading from "vue-loading-overlay";
import "vue-loading-overlay/dist/vue-loading.css";
import swal from "sweetalert2";
import "sweetalert2/dist/sweetalert2.css";
import PaymentPlan from "@/views/Components/PaymentPlan/PaymentPlan.vue";
import Transaction from "@/views/Components/Transactions/Transaction.vue";
import CustomerMembershipBilling from "@/views/Components/CustomerMembershipBilling/CustomerMembershipBilling.vue";
import Notification from "@/views/Components/Notifications/Notification.vue";

export default {
  components: {
    "loading-overlay": Loading,
    "payment-plan": PaymentPlan,
    transaction: Transaction,
    "customer-membership-billing": CustomerMembershipBilling,
    "notification-control": Notification,
  },
  data() {
    return {
      loading: false,
      name: null,
      paymentPlanId: null,
      showUserNotifications: false,
      transactionId: null,
      customerMembershipBillingId: null,
      notificationId: null,
      apptId: null,
    };
  },
  methods: {
    setName(name) {
      this.name = name;
    },
  },
  mounted() {
    var self = this;

    self.$emitter.on("show-notification", (id) => {
      self.notificationId = id;
      self.$refs.notificationModal.show();
    });

    self.$emitter.on("show-customer-membership-billing", (id) => {
      self.customerMembershipBillingId = id;
      self.$refs.customerMembershipBillingModal.show();
    });

    self.$emitter.on("show-transaction", (id) => {
      self.transactionId = id;
      self.$refs.transactionModal.show();
    });

    self.$emitter.on("show-paymentplan", (paymentPlanId) => {
      self.paymentPlanId = paymentPlanId;
      self.$refs.paymentPlanModal.show();
    });

    self.$emitter.on("success", (e) => {
      this.$notify({
        type: "success",
        verticalAlign: "top",
        horizontalAlign: "center",
        message: e.message,
      });
      self.loading = false;
    });
    self.$emitter.on("error", (e) => {
      this.$notify({
        type: "danger",
        verticalAlign: "top",
        horizontalAlign: "center",
        message: e,
      });
      self.loading = false;
    });
    self.$emitter.on("response-noSuccess", (e) => {
      var error = "";
      e.forEach((item) => {
        error = error + item + "<br/>";
      });
      this.$notify({
        type: "danger",
        verticalAlign: "top",
        horizontalAlign: "center",
        message: error,
      });
      self.loading = false;
    });
    self.$emitter.on("response-validationErrors", (e) => {
      this.$notify({
        type: "danger",
        verticalAlign: "top",
        horizontalAlign: "center",
        message: "Validation Errors",
      });
      self.loading = false;
    });
    self.$emitter.on("loading-start", (e) => {
      self.loading = true;
    });
    self.$emitter.on("loading-end", (e) => {
      self.loading = false;
    });
    self.$emitter.on("response-error", (e) => {
      self.$root.$bvToast.toast(e.message, {
        title: "Error",
        autoHideDelay: 5000,
        variant: "danger",
        solid: true,
      });
      self.loading = false;
    });
    self.$emitter.on("request-error", (e) => {
      self.$root.$bvToast.toast("There was an error requesting", {
        title: "Error",
        autoHideDelay: 5000,
        variant: "danger",
        solid: true,
      });
      self.loading = false;
    });
    self.$emitter.on("success-confirm", (e) => {
      if (e.navigate) {
        swal
          .fire({
            title: e.title,
            text: e.message,
            iconHtml: e.iconHtml ? e.iconHtml : null,

            buttonsStyling: false,
            confirmButtonClass: "btn btn-success",
            icon: "success",
          })
          .then(() => {
            window.location.href = e.navigate;
          });
      } else {
        swal.fire({
          title: e.title,
          text: e.message,
          buttonsStyling: false,
          confirmButtonClass: "btn btn-success",
          icon: "success",
        });
      }
    });
    self.$emitter.on("noSuccess-confirm", (e) => {
      swal.fire({
        title: e.title,
        text: e.message,
        buttonsStyling: false,
        confirmButtonClass: "btn btn-danger",
        icon: "error",
      });
    });
  },
};
</script>
<style>
.modal {
  z-index: 1101 !important;
}

/**
* Vue Sweet Alert
*/
.swal-overlay {
  z-index: 1122 !important;
}

/**
* Vue Loading
*/
.vld-overlay.is-full-page {
  z-index: 1103 !important;
}
</style>
